import { render, staticRenderFns } from "./RegistrationTitle.vue?vue&type=template&id=e21f5946"
import script from "./RegistrationTitle.vue?vue&type=script&lang=js"
export * from "./RegistrationTitle.vue?vue&type=script&lang=js"
import style0 from "./RegistrationTitle.vue?vue&type=style&index=0&id=e21f5946&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports